import { useRecoilState } from 'recoil';
import { aInvitationLanguage } from './atom';

export const useInvitationLanguage = (): any => {
    return useRecoilState(aInvitationLanguage);
};
